import React from "react";
import { Alert, Button} from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const ProfileIncompleteAlert = ( { navigateTo }) => {
    const navigate = useNavigate ();
    return (
            <Alert
      message="Profile Incomplete"
      description="Complete your profile to unlock all features"
      type="warning"
      showIcon
      icon={<ExclamationCircleFilled />}
      style={{
        marginBottom: 24,
        backgroundColor: "#fffbe6",
        border: "1px solid #ffe58f",
        borderRadius: 8,
      }}
      action={
        <Button
          type="primary"
          size="small"
          style={{
            marginLeft: 16,
            backgroundColor: "#2f5969ff", // zinc
            borderColor: "#52525b",
            color: "#fff",
            fontWeight: 500,
          }}
          onClick={() => navigate(navigateTo)}
        >
          Complete Profile
        </Button>
      }
    />
  );
};

ProfileIncompleteAlert.propTypes = {
  navigateTo: PropTypes.string.isRequired,
};

export default ProfileIncompleteAlert;
